






import type { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CdlResultOtherOptions extends Vue {
  @Prop({ required: true })
  item: Result;

  get minPrice() {
    const prices = Object.values(this.item.price).filter(price => price > 0);
    return prices.length ? Math.min(...prices) : 0;
  }

  get formattedMinPrice() {
    return this.$options.filters.currency(this.minPrice);
  }
}
